'use strict';

var ticky = require('ticky');

module.exports = function debounce (fn, args, ctx) {
  if (!fn) { return; }
  ticky(function run () {
    fn.apply(ctx || null, args || []);
  });
};



//////////////////
// WEBPACK FOOTER
// C:/projects/wct-nextias-ui/node_modules/contra/debounce.js
// module id = ../../../../contra/debounce.js
// module chunks = common